<template>
  <div id="switcher" class="map-switcher">
    <a-radio-group button-style="solid" 
      :default-value="defaultPaneId"
      :size="buttonSize" @change="onChange">
      <a-radio-button 
        :value="pane.value" 
        v-for="pane in panes" :key="pane">
        {{ pane.text }}
      </a-radio-button>
    </a-radio-group>
  </div> 
</template>

<script>

export default {
  props: ["defaultPaneId", "panes"],

  data() {
    return {
      screenWidth: document.body.clientWidth,
    }
  },

  mounted() {
    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    }
  },

  computed: {
    buttonSize() {
      return this.screenWidth > 780 ? 'large' : 'middle'
    },
  },

  methods: {
    onChange(event) {
      const paneId = event.target.value
      console.log("[switcher]", paneId)
      this.$emit("switchPane", paneId)
    }
  },

  watch: {
    screenWidth(val) {
      this.screenWidth = val
    }
  }
}
</script>

<style>
#switcher {z-index: 30; right: 20px; top:10px; position: absolute}
#switcher label.btn {white-space: nowrap}
#switcher-vertical {z-index: 30; right: 20px; top:10px;display: none;}
#switcher-vertical label.btn {white-space: nowrap}

@media (max-width: 780px) {
    #logo .company-logo {background-size: 80px; width: 80px; height: 16px;}

    #switcher {z-index: 30; right: 10px; top:10px; position: absolute}
    #switcher .ant-radio-button-wrapper { 
      width:100%; 
      border-left: 1px; 
      border-left-style: solid;
      border-left-color: #e9e9e9;
      border-bottom-width: 0px
    }
    #switcher .ant-radio-group-solid .ant-radio-button-wrapper-checked {
      border-color: #1890ff;
    }
    #switcher .ant-radio-button-wrapper:first-child {
      border-radius: 2px 2px 0px 0px;
    }
    #switcher .ant-radio-button-wrapper:last-child {
      border-radius: 0px 0px 2px 2px;
      border-bottom-width: 1px
    }
    #switcher .ant-radio-group {width: 84px;}
}

/* btn-group */
#switcher .btn-group {background-color: rgba(255, 255, 255, 0.8); border-radius:0.25rem;}
#switcher .btn-group .form-check-inline {margin-right: 0;}

#switcher .btn-group>.form-check-inline:not(:last-child) .btn {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

#switcher .btn-group>.form-check-inline:not(:first-child) .btn {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

/* antdv */
#switcher .ant-radio-button-wrapper { padding: 0px 12px }
</style>

